














import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class AddressSearchButton extends Vue {

  @Prop()
  disabled: boolean

  onClick(event) {
    this.$emit('click', event)
  }

  get buttonLabel(): string {
    return this.disabled ? '検索中' : '検索'
  }
}
